export default __webpack_public_path__ + "static/media/AddButtonSVG.1f80b4a6.svg";